import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const useLocations = ({ activityId, regionId }) => {
  const queryParams = new URLSearchParams();
  if (activityId) queryParams.append('activityId', activityId);
  if (regionId) queryParams.append('regionId', regionId);

  const urlStr = `${getApiUrl()}/location?${queryParams.toString()}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 30 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};
